import { Col, Offcanvas, Row } from "react-bootstrap";
import { KPSelfSignificator } from "../App/KPPage/KPSelfSignificator";

export function SelfOffCanvas({showpopup,handlePopup,userData, clientData}){
  return (
    <> 
      <Offcanvas show={showpopup} onHide={handlePopup} placement="bottom" backdrop={false} style={{"height":"40vh", opacity: 1.0,"overflow-y": "auto"}}>
        <Offcanvas.Body class="m-0 p-0 align-middle">
          <Row id="birthChart" className="m-0 p-0">
            <Col xs={12} lg={3} className="m-0 p-0"></Col>
            <Col xs={12} lg={6} className="p-2 pt-0 m-0">
              <KPSelfSignificator userData={userData} clientData={clientData}/>
            </Col>
            <Col xs={12} lg={3} className="m-0 p-0" ></Col>
          </Row>  
        </Offcanvas.Body>
      </Offcanvas>        
    </>
  );
}